import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Alert,
  Loader,
  View} from "@aws-amplify/ui-react";
import "./Task.css";
import { getTaskListAPI } from "../../data/api";
import TaskCard from "./TaskCard";

const TaskList = (props) => {
  const [taskList, setTaskList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [error, setError] = useState(false);
  const [emptyState, setEmptyState] = useState(false);
  const [isLastPage, setIsLastPage] = useState(false);
  const pageSize = 10;
  const observer = useRef<IntersectionObserver | null>(null);

  const updateTask = (updatedTask) => {
    setTaskList((prevTaskList) =>
      prevTaskList.map((task) => (task.id === updatedTask.id ? updatedTask : task))
    );
  };

  const loadNextPage = async () => {
    if(!isLastPage){
      getTaskList();
    }
  };

  const getTaskList = async () => {    
    try{
      setLoading(true);
      setEmptyState(false);
      setError(false);
      const taskListPage = await getTaskListAPI(taskList.filter(t => t.completato == props.completato).length, pageSize, props.completato)
      setIsLastPage(taskListPage.last);
      setTaskList([...taskList, ...taskListPage.tasks]);
      setLoading(false);
    } catch (e) {
      if(e.statusCode === 404){
        if(taskList.length === 0){
          console.log('No task found for user ', e);
          setEmptyState(true);
        } else {
          setIsLastPage(true);
        }
      } else {
        console.log('Loading task list failed ', e);
        setError(true);
      }
      setLoading(false);
    }
  }

  useEffect(() => {
    getTaskList();
  }, [])

  const lastItemRef = useCallback((node: HTMLDivElement) => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        loadNextPage();
      }
    });

    if (node) observer.current.observe(node);
  }, [loading, loadNextPage]);

  return (
    <>
    <View
      backgroundColor="var(--amplify-colors-white)"
      borderRadius="6px"
      maxWidth="100%"
      padding="1rem"
      marginBottom="20px"
    >
      {
        error ? <Alert variation="error">Errore nel caricamento dei dati</Alert> : 
        emptyState ? <Alert variation="info">Nessun task trovato</Alert> :
        <>
          {taskList.map(task => 
              <View key={task.id} padding="0" marginBottom="20px" width="100%">
                <TaskCard task={task} loading={loading} onUpdate={updateTask} onLoading={(loading) => {updateTask({...task, loading: loading})}}/>
              </View>)
          }
          { (taskList.find((t) => t.loading) === undefined) && <div ref={lastItemRef} /> } 
          { loading && <Loader/> } 
        </>
      }
    </View>
    </>
  );
};

export default TaskList;
